export enum TranslateLang {
  'CZ' = 'general.language.shortcut-option-1',
  'EN' = 'general.language.shortcut-option-2',
  'DE' = 'general.language.shortcut-option-3',
}

export enum Lang {
  'CZ' = 'CZ',
  'EN' = 'EN',
  'DE' = 'DE',
}

export const languageOptions = [
  {
    value: 'CZ',
    label: 'general.language.modal-select-option-1',
  },
  {
    value: 'EN',
    label: 'general.language.modal-select-option-2',
  },
  {
    value: 'DE',
    label: 'general.language.modal-select-option-3',
  },
];
